/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiLeadProcessStatus;
(function (ApiLeadProcessStatus) {
    ApiLeadProcessStatus["LEAD_STATUS_UNSPECIFIED"] = "LeadStatusUnspecified";
    ApiLeadProcessStatus["LEAD_STATUS_EXTERNAL_ID_CALCULATED"] = "LeadStatusExternalIdCalculated";
})(ApiLeadProcessStatus || (ApiLeadProcessStatus = {}));
export function ApiLeadProcessStatusFromJSON(json) {
    return ApiLeadProcessStatusFromJSONTyped(json, false);
}
export function ApiLeadProcessStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiLeadProcessStatusToJSON(value) {
    return value;
}
